import { DashboardSubscription } from "../services/userService";

const ACTIVE_STATUSES = new Set(["active"]);

export function hasActiveSubscription(subscriptions: DashboardSubscription[] = []): boolean {
  return subscriptions.some((subscription) => {
    const subscriptionStatus = subscription.status?.toLowerCase();
    const paymentStatus = subscription.payment_status?.toLowerCase();

    return (
      ACTIVE_STATUSES.has(subscriptionStatus) ||
      ACTIVE_STATUSES.has(paymentStatus)
    );
  });
}
